"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var Tickers_st_css_1 = require("./Tickers.st.css");
var Tickers = /** @class */ (function (_super) {
    tslib_1.__extends(Tickers, _super);
    function Tickers() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleIncrement = function (e) {
            e.preventDefault();
            _this.props.onIncrement(e);
        };
        _this.handleDecrement = function (e) {
            e.preventDefault();
            _this.props.onDecrement(e);
        };
        return _this;
    }
    Tickers.prototype.render = function () {
        return (React.createElement("div", { className: Tickers_st_css_1.st(Tickers_st_css_1.classes.root, this.props.className) },
            React.createElement("button", { tabIndex: -1, type: "button", onMouseDown: this.handleIncrement, className: Tickers_st_css_1.classes.ticker, disabled: this.props.disabled, "data-hook": "ticker-button-up" }, this.props.tickerUpIcon),
            React.createElement("button", { tabIndex: -1, type: "button", onMouseDown: this.handleDecrement, className: Tickers_st_css_1.classes.ticker, disabled: this.props.disabled, "data-hook": "ticker-button-down" }, this.props.tickerDownIcon)));
    };
    return Tickers;
}(React.PureComponent));
exports.Tickers = Tickers;
//# sourceMappingURL=Tickers.js.map